<template>
<div class="columns is-marginless">
    <div class="column is-4">
        <router-link :to="item.url" class="is-block">
            <figure>
                <img :src="item.thumb.url" />
            </figure>
        </router-link>
    </div>
    <router-link :to="item.url" class="is-block column is-6">
        <p class="product-title">{{item.quantity}} x <strong>{{item.title}}</strong></p>
        <p class="product-price">{{(item.special_price ? item.special_price : item.price).toDollar()}}</p>
    </router-link>
    <div class="column is-narrow">
        <button :class="['btn-remove-order-item', {'is-loading' : is_deleting}]" @click.prevent="remove_order_item()"><i class="fas fa-trash"></i></button>
    </div>
</div>
</template>

<script>
export default {
    name    :   'MiniCartItem',
    props   :   ['item'],
    data()
    {
        return {
            is_deleting :   false
        };
    },
    methods :   {
        remove_order_item()
        {
            if (this.is_deleting) return false;
            if (confirm('You are going to remove this item from your cart. Are you sure?')) {
                this.is_deleting    =   true;
                let data    =   new FormData();
                data.append('csrf', this.$parent.site_data.session.csrf);
                data.append('id', this.item.id);
                axios.post(
                    base_url + endpoints.cart + 'delete',
                    data
                ).then((resp) => {
                    this.is_deleting    =   false;
                    this.$bus.$emit('onCartUpdate', resp.data);
                }).catch((error) => {
                    this.is_deleting    =   false;
                });
            }
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/elements/MiniCartItem.vue